import React from "react";
import { ChevronRight, Home } from "lucide-react";
import { ENTITY_COLORS } from "@/lib/entityColors";

export function Breadcrumb({ breadcrumb, nodeMap, onJump }) {
  if (!breadcrumb || breadcrumb.length === 0) return null;
  return (
    <div
      className="flex items-center gap-1 px-6 h-11 border-b border-[#14140f]/10 bg-[#fdfdfb]/80 backdrop-blur-sm overflow-x-auto"
      data-testid="graph-breadcrumb"
    >
      <Home className="w-3.5 h-3.5 text-[#14140f]/35 shrink-0" />
      {breadcrumb.map((id, i) => {
        const node = nodeMap[id];
        const last = i === breadcrumb.length - 1;
        return (
          <React.Fragment key={`${id}-${i}`}>
            <ChevronRight className="w-3.5 h-3.5 text-[#14140f]/25 shrink-0" />
            <button
              onClick={() => onJump(i)}
              data-testid={`breadcrumb-${id}`}
              className={`flex items-center gap-1.5 text-sm whitespace-nowrap px-1.5 py-0.5 rounded transition-colors ${
                last ? "text-[#14140f] font-semibold" : "text-[#14140f]/55 hover:text-[#14140f]"
              }`}
            >
              {node && (
                <span
                  className="w-2 h-2 rounded-full shrink-0"
                  style={{ background: ENTITY_COLORS[node.type] || "#ff7360" }}
                />
              )}
              {node ? node.label : id}
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}
